import React, {useState} from 'react';

import ReactTable from 'react-table'

import useReduceStore from 'hooks/ReduceStoreHook';

import DateComponent from 'views/DateComponent';
import AppUtil from 'AppUtil';
import {A} from 'views/AppElements';
import SessionStore from 'stores/SessionStore';
import ProductAPI from 'service/api/ProductAPI';
import ProductStore from 'stores/ProductStore';
import SetoCanvasPage from 'pages/SetoCanvasPage';

import AppConstants from 'AppConstants';




function DiscountedProductsTable({discountedProducts}) {
    const productInfoCols = [{Header: 'Name', accessor: 'product', width: 220, 
                            Cell: function(props) {
                                const product = props.value;
                                const url = AppUtil.getProductURL(product);
                                return <A href={url} style={{marginLeft: '10px'}}>{product.title}</A>
                            }
                        }, 
                        {Header: 'Type', accessor: 'product', width: 130, 
                            Cell: function(props) {
                                const product = props.value;
                                return AppConstants.PRODUCT_TYPES[product.productType].label;
                            }
                        }
                        ];
                        

    const discountedCouponCols = [{Header: 'Coupon Code', accessor: 'discountCoupon', width: 200, 
                            Cell: function(props) {
                                const discountCoupon = props.value;
                                return <div className="couponCode">{discountCoupon.couponCode}</div>
                            }
                        }, 
                        {Header: 'Amount', accessor: 'discountCoupon', width: 220, 
                            Cell: function(props) {
                                const discountCoupon = props.value;
                                return <div style={{textAlign: 'center'}}>{"Rs. "+discountCoupon.discountAmount}</div>
                            }
                        },
                        {Header: 'Orders Limit', accessor: 'discountCoupon', width: 150, 
                            Cell: function(props) {
                                const ordersLimit = props.value.ordersLimit? "First "+props.value.ordersLimit+" Orders!": "-";
                                return <div>{ordersLimit}</div>
                            }
                        },
                        {Header: 'Validity', accessor: 'discountCoupon', width: 150, 
                            Cell: function(props) {
                                const discountCoupon = props.value;
                                const now = new Date().getTime();
                                
                                if(now < discountCoupon.startTime) {
                                    const from = <DateComponent date={discountCoupon.startTime} relative={true} showTime={true} />;
                                    return <div>Valid {from}</div>
                                }
                                
                                const to = <DateComponent date={discountCoupon.expiryTime} relative={true} showTime={true} />;
                                return <div>Expires {to}</div>
                            }
                        },
                        
                        ];
                     
    const showLoading = discountedProducts? false: true;

    let columns = [{Header: 'Product', columns: productInfoCols}];
    columns.push({Header: 'Discount', columns: discountedCouponCols});

    return <ReactTable data={discountedProducts? discountedProducts: []} columns={columns} minRows={5} 
            noDataText="No Discounts Found." loading={showLoading} 
            className="-highlight" defaultPageSize={15} 
            />
}

function DiscountedProductsPage(props) {
    const session = useState(SessionStore.getCurrentSession())[0];
    
    let userId = props.match.params.userId;

    if(!userId)
        userId = session.user.id;

    const discountedProducts = useReduceStore(ProductStore, (store) => store.getDiscountedProducts(userId), 
                                            () => ProductAPI.getDiscountedProducts(userId), [userId]);

    return (<SetoCanvasPage id="discountedProductsPage" title="Discounted Products | Seto Canvas">
        <h2 style={{margin: '10px 0'}}>Discounts and Coupons <i className="fa fa-tags" aria-hidden="true"></i></h2>
        <DiscountedProductsTable discountedProducts={discountedProducts} />
    </SetoCanvasPage>)
}

export default DiscountedProductsPage;


// WEBPACK FOOTER //
// ./src/pages/DiscountedProductsPage.js